import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'lg';
  arrow?: boolean;
  href?: string;
  target?: '_blank';
  rel?: string;
  onClick?: () => void;
  ariaLabel?: string;
};
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'lg',
  arrow = false,
  href,
  target,
  rel,
  onClick,
  ariaLabel
}: ButtonProps) {
  const styles = {
    primary: 'bg-cta text-cta-foreground shadow-sm transition-[background-color,transform] hover:bg-cta-hover active:scale-[0.98]',
    secondary: 'bg-background text-foreground border border-border shadow-sm transition-[background-color,transform] hover:bg-surface-hover active:scale-[0.98]',
    outline: 'border border-primary bg-transparent text-primary transition-colors hover:bg-primary/5'
  };
  const sizes = {
    sm: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3.5 text-base sm:px-8 sm:py-4'
  };
  const classes = `inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 ${styles[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-191" data-mp="onkh37ndfgff">
        {children}
        {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-192" data-mp="12lsdneghwfq2" />}
      </a>;
  }
  return <button type="button" onClick={onClick} className={classes} aria-label={ariaLabel} data-id="element-193" data-mp="xnz6oj7dbhoq">
      {children}
      {arrow && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-194" data-mp="1ccmwe8uj8x6r" />}
    </button>;
}